import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { AuthService } from '../../../auth/services/auth.service';
import { Store } from '@ngrx/store';
import * as fromAuth from '../../../../store/auth';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest } from 'rxjs';
import { UserHasPushSubscription } from '../../../auth/models/IGlimpseUser';

@UntilDestroy()
@Component({
    selector: 'app-enable-push-panel',
    templateUrl: './enable-push-panel.component.html',
    styleUrls: ['./enable-push-panel.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EnablePushPanelComponent implements OnInit {
  user$ = this.store.select(fromAuth.selectUser);
  working$ = this.store.select(fromAuth.selectUserLoading);

  error: string;

  constructor(
    private auth: AuthService,
    private ref: MatSnackBarRef<void>,
    private store: Store<{
      auth: fromAuth.AuthState;
    }>,
  ) {}

  ngOnInit(): void {
    combineLatest([this.user$, this.auth.existingPushSubscription()])
      .pipe(untilDestroyed(this))
      .subscribe(([user, existingSub]) => {
        let hasThisSub = UserHasPushSubscription(user, existingSub);
        if (hasThisSub) this.ref.dismissWithAction();
      });
  }

  static open(snackbar: MatSnackBar) {
    return snackbar.openFromComponent(EnablePushPanelComponent, {
      duration: 600 * 1000,
      politeness: 'off',
    });
  }

  async enablePush() {
    let pushSubscription: PushSubscription;
    try {
      pushSubscription = await this.auth.requestForPush();
    } catch (exc) {
      this.error = exc?.message ?? 'Push disabled';
      setTimeout(() => {
        this.ref.dismiss();
      }, 5000);
    }
    if (pushSubscription) this.store.dispatch(fromAuth.pushEnable({ sub: pushSubscription }));
  }

  dismiss() {
    this.auth.dismissPush();
    this.ref.dismiss();
  }
}
